module.exports = __webpack_public_path__ + "img/loginer.a5b6a43c.png";